/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function(formData) {
  var deferred = $.Deferred();

  $.soap({
    body: {
      SubmitEntityDirector: {
        $xmlns: 'http://dobs.pa.gov/dp/director/bpm/1.0',
        Director: {
          DirectorID: formData.directorId,
          EntityID: formData.entityId,
          PositionHeld: formData.positionHeld,
          FirstName: formData.firstName,
          LastName: formData.lastName,
          MiddleInitial: formData.middleInitial,
          TermLength: formData.termLength,
          StatusID: formData.statusId,
          TermStartDate: formData.termStartDate,
          TermEndDate: formData.termEndDate,
          ElectionDate: formData.electionDate,
          ElectionBasisID: formData.electionBasisId,
          ReasonID: formData.reasonId,
          IsChairman: formData.isChairman,
          Comment: formData.comment,
          IsDeleted: formData.isDeleted,
          PositionHeldID: formData.positionHeldId
        }
      }
    },
    blueprint: {
      directorId: '$..DirectorID'
    }
  })
    .done(function(response) {
      cleanUpResponse(response, { cleanUpTextKeys: true });
      deferred.resolve(response.directorId);
    })
    .fail(function(err) {
      deferred.reject();
    });

  return deferred.promise();
};
